var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Icon as AntIcon } from '@ant-design/compatible';
import Popover from 'antd/lib/popover';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import { polyfill } from 'react-lifecycles-compat';
import { getBgImageUrl, getBgImageType, defaultBgImageValue } from '../../utils';
import BackGroundPop from './BackGroundPop';
var BackGroundImage = /** @class */ (function (_super) {
    __extends(BackGroundImage, _super);
    function BackGroundImage(props) {
        var _this = _super.call(this, props) || this;
        _this.onDragEnd = function (result) {
            var source = result.source, destination = result.destination;
            if (destination && source.index !== destination.index) {
                var value_1 = _this.props.value;
                Object.keys(value_1).forEach(function (key) {
                    var item = value_1[key];
                    var removed = item.splice(source.index, 1)[0];
                    item.splice(destination.index, 0, removed);
                    value_1[key] = item;
                });
                _this.props.onChange(value_1);
            }
        };
        _this.onDeleteChild = function (i) {
            var value = _this.props.value;
            Object.keys(value).forEach(function (key) {
                var item = value[key];
                item.splice(i, 1);
                value[key] = item;
            });
            _this.props.onChange(value);
        };
        _this.onAdd = function () {
            var value = _this.props.value;
            Object.keys(value).forEach(function (key) {
                value[key].unshift(defaultBgImageValue[key]);
            });
            _this.keys.unshift(_this.getRand());
            _this.addNum = 0;
            _this.props.onChange(value);
        };
        _this.getRand = function () { return (Math.random() + Date.now()).toString(16).replace('.', Math.random().toFixed(6).replace('0.', '')); };
        _this.getChildrenToRender = function () {
            var _a = _this.props, className = _a.className, data = _a.value, props = __rest(_a, ["className", "value"]);
            var children = data.image.filter(function (c) { return c; }).map(function (url, i) {
                var type = getBgImageType(url);
                var imageNameSplit = getBgImageUrl(url).split('/');
                var name = type === 'img' ? imageNameSplit[imageNameSplit.length - 1]
                    : type + "-gradient";
                _this.keys[i] = _this.keys[i] || _this.getRand();
                var defaultVisible;
                if (i === _this.addNum) {
                    defaultVisible = true;
                    _this.addNum = NaN;
                }
                return (React.createElement(Draggable, { key: _this.keys[i], index: i, draggableId: _this.keys[i] }, function (provided) {
                    return (React.createElement(Popover, { content: (React.createElement(BackGroundPop, __assign({}, props, { value: data, num: i }))), defaultVisible: defaultVisible, trigger: "click", overlayClassName: "editor-list-popover", destroyTooltipOnHide // svg defs 阴藏后不会显示渐变了。
                        : true },
                        React.createElement("div", __assign({ ref: provided.innerRef }, provided.draggableProps, { className: className + "-list" }),
                            React.createElement(AntIcon, __assign({ className: className + "-list-bar", type: "menu" }, provided.dragHandleProps)),
                            React.createElement("div", { style: { backgroundImage: url }, className: className + "-list-preview" }),
                            React.createElement("a", { className: className + "-list-name" }, name),
                            React.createElement("div", { className: className + "-list-delete", onClick: function () {
                                    _this.onDeleteChild(i);
                                } },
                                React.createElement(AntIcon, { type: "delete" })))));
                }));
            });
            return (React.createElement(Row, { gutter: 8 },
                React.createElement(Col, null,
                    React.createElement(DragDropContext, { onDragStart: _this.onDragStart, onDragEnd: _this.onDragEnd },
                        React.createElement(Droppable, { key: "bgImage", droppableId: "bgImage" }, function (provided) {
                            return (React.createElement("div", { ref: provided.innerRef, className: className + "-droppable" },
                                children,
                                provided.placeholder));
                        })))));
        };
        _this.keys = [];
        _this.state = {
            $self: _this,
        };
        return _this;
    }
    BackGroundImage.getDerivedStateFromProps = function (props, _a) {
        var prevProps = _a.prevProps, $self = _a.$self;
        var nextState = {
            prevProps: props,
        };
        if (prevProps) {
            if (props.editorElem !== prevProps.editorElem) {
                $self.keys = [];
            }
        }
        return nextState;
    };
    BackGroundImage.prototype.componentWillUnmount = function () {
        this.keys = [];
    };
    BackGroundImage.prototype.render = function () {
        var _a = this.props, locale = _a.locale, className = _a.className;
        var childToRender = this.getChildrenToRender();
        return (React.createElement("div", { className: className + "-wrapper" },
            childToRender,
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, { span: 24 },
                    React.createElement("a", { className: "add-button", onClick: this.onAdd },
                        React.createElement(AntIcon, { type: "plus" }),
                        ' ',
                        locale.add)))));
    };
    BackGroundImage.propTypes = {
        className: PropTypes.string,
        locale: PropTypes.object,
        value: PropTypes.any,
        onChange: PropTypes.func,
        editorElem: PropTypes.any,
    };
    BackGroundImage.defaultProps = {
        className: 'editor-bg-image',
    };
    return BackGroundImage;
}(React.Component));
export default polyfill(BackGroundImage);
